import Project from "../components/project";

const Web333 = () => {
  const images = {
    desktop: "projects/web333-desktop.png",
    tablet: "projects/web333-tablet.png", 
    mobile: "projects/web333-mobile.png",
  };

  return <Project images={images} />;
}

export default Web333
